import {
  GET_PROFILE,
  PROFILE_ERROR,
  CLEAR_PROFILE,
  UPDATE_PROFILE,
  SET_PROFILE_STATUS,
  JOIN_PROFILE_COMMUNITY,
  UNJOIN_PROFILE_COMMUNITY,
  CLEAR_MSG,
} from "../actions/types";

const initialState = {
  profile: {},
  profilestatus: "",
  members: [],
  profileloading: true,
  error: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_PROFILE:
    case UPDATE_PROFILE:
      return {
        ...state,
        profile: payload,
        members: payload.members,
        profileloading: false,
      };
    case JOIN_PROFILE_COMMUNITY:
      return {
        ...state,
        members: [payload, ...state.members],
      };
    case UNJOIN_PROFILE_COMMUNITY:
      return {
        ...state,
        members: state.members.filter((member) => member.channelid !== payload),
      };
    case PROFILE_ERROR:
      return {
        ...state,
        profile: state.profile,
        error: payload,
        profileloading: false,
      };
    case CLEAR_PROFILE:
      return {
        ...state,
        profile: {},
        profilestatus: "",
        profileloading: true,
        error: {},
      };
    case CLEAR_MSG:
      return {
        ...state,
        msg: "",
      };
    case SET_PROFILE_STATUS:
      return {
        ...state,
        profilestatus: payload,
        profileloading: false,
      };
    default:
      return state;
  }
}
